export const COURSE_TITLE = "Welcome to GreenEn";

export const LMS_TOAST_MESSAGES = {
  COURSE_FETCH_FAILED: "Failed to fetch courses",
  COURSE_DETAILS_FETCH_FAILED: "Failed to fetch course details",
  CREATE_COURSE_SUCCESS: "Course created successfully",
  CREATE_COURSE_FAILURE: "Failed to create course",
  CREATE_MODULE_SUCCESS: "Course created successfully",
  CREATE_MODULE_FAILURE: "Failed to create course",
  UPDATE_COURSE_FAILURE: "Failed to update course",
  CONTENT_TYPE_FILE_REQUIRED: "Content type changed. Please upload a file of the new type.",
  FILE_IS_REQUIRED: "File is required for new modules",
  TITLE_IS_REQUIRED: "Title is required for modules",
  UPDATE_MODULE_FAILURE: "Failed to update module"
};

export const CONTENT_TYPE = {
  VIDEO: "video",
  TEXT: "text",
  AUDIO: "audio",
  PDF: "pdf",
  PPT: "ppt",
  PPTX: "ppt"
};

export const COURSE_TOAST_MESSAGES = {
  MODULE_FETCH_FAILED: "Failed to load module",
  MODULE_MARK_COMPLETE_FAILED: "Failed to mark module complete",
  MODULE_MARKED_COMPLETE: "Module marked as completed",
  COURSE_TITLE_REQUIRED: "Course title is required",
  COURSE_DESCRIPTION_REQUIRED: "Course description is required"
};

export const COURSE_LIST_TABS = {
  COURSES: "courses",
  PROGRESS: "progress",
};

export const COURSE_STATUS = {
  COMPLETED: "Completed",
  PROGRESS: "Progress",
};

